/* tslint:disable */
/* eslint-disable */
export enum WorkLedgerModeEnum {
  External = 'external',
  Internal = 'internal'
}
